import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Collapse,
  Chip,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

function SuggestedQuestions({ expanded, setExpanded, onSelectQuestion }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const suggestedQuestions = [
    t('chatWindow.suggestedQuestion1'),
    t('chatWindow.suggestedQuestion2'),
    t('chatWindow.suggestedQuestion3'),
    t('chatWindow.suggestedQuestion4'),
  ];

  const handleQuestionClick = (question) => {
    onSelectQuestion(question);
    setExpanded(false);
  };

  const handleToggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <Box
        sx={{
          p: isMobile ? 1 : 1.5,
          bgcolor: theme.palette.background.paper,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          '&:hover': {
            bgcolor:
              theme.palette.mode === 'dark'
                ? 'rgba(255,255,255,0.05)'
                : 'rgba(0,0,0,0.03)',
          },
          transition: 'background-color 0.2s ease',
          borderBottom: expanded
            ? `1px solid ${theme.palette.divider}`
            : 'none',
        }}
        onClick={handleToggleExpanded}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: isMobile ? '0.7rem' : '0.8rem',
            fontWeight: 500,
          }}
        >
          {t('chatWindow.suggestedQuestions')}
        </Typography>
        <IconButton
          size="small"
          sx={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          <ExpandMoreIcon fontSize={isMobile ? 'small' : 'medium'} />
        </IconButton>
      </Box>
      <Collapse in={expanded} timeout={300}>
        <Box
          sx={{
            p: isMobile ? 1.5 : 2,
            bgcolor:
              theme.palette.mode === 'dark'
                ? 'rgba(0,0,0,0.1)'
                : 'rgba(0,0,0,0.02)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: isMobile ? 0.5 : 1,
            }}
          >
            {suggestedQuestions.map((question, index) => (
              <Chip
                key={index}
                label={question}
                variant="outlined"
                size="small"
                onClick={() => handleQuestionClick(question)}
                sx={{
                  cursor: 'pointer',
                  fontSize: isMobile ? '0.65rem' : '0.75rem',
                  height: isMobile ? '28px' : '32px',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderColor: 'primary.main',
                    transform: 'translateY(-1px)',
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Collapse>
    </>
  );
}

export default SuggestedQuestions;
